let product = document.querySelectorAll('.product'),
    productOffsetTop,
    productOffsetBottom,
    scroll = window.scrollY,
    windowWidth = window.innerWidth

function detectProduct(scroll) {

    let html = document.querySelector('html')

    // Fix product section
    product.forEach((element) => {

        productOffsetTop = element.offsetTop
        productOffsetBottom = element.offsetTop + element.offsetHeight

        if ( scroll >= productOffsetTop && scroll <= productOffsetBottom ) {
            element.classList.add('product--fixed')
            html.classList.add('snap-disabled')
        } else {
            element.classList.remove('product--fixed')
        }

    })

}

if (windowWidth > 767) {

    window.addEventListener('scroll', () => {
        scroll = window.scrollY
        detectProduct(scroll)
    })

    detectProduct(scroll)


    // Scale product image
    let range = 1 / 1300
    let vw = range * Math.min(window.innerWidth, window.innerHeight)

    if (vw <= 1) {
        document.documentElement.style.setProperty('--product-image-scale', `${vw}`)
    }


    // Scale product titles
    let range1 = 1 / 930
    let vw1 = range1 * Math.min(window.innerWidth, window.innerHeight)

    if (vw1 <= 1) {
        document.documentElement.style.setProperty('--product-title-scale', `${vw1}`)
    }


    // Scale recipe image
    let range2 = 1 / 850
    let vw2 = range2 * Math.min(window.innerWidth, window.innerHeight)

    if (vw2 <= 1) {
        document.documentElement.style.setProperty('--recipe-image-scale', `${vw2}`)
    }


    window.addEventListener('resize', () => {

        let val1 = range * Math.min(window.innerWidth, window.innerHeight)
        if (val1 <= 1) {
            document.documentElement.style.setProperty('--product-image-scale', `${range * Math.min(window.innerWidth, window.innerHeight)}`)
        }

        let val2 = range1 * Math.min(window.innerWidth, window.innerHeight)
        if (val2 <= 1) {
            document.documentElement.style.setProperty('--product-title-scale', `${range1 * Math.min(window.innerWidth, window.innerHeight)}`)
        }

        let val3 = range2 * Math.min(window.innerWidth, window.innerHeight)
        if (val3 <= 1) {
            document.documentElement.style.setProperty('--recipe-image-scale', `${range2 * Math.min(window.innerWidth, window.innerHeight)}`)
        }

    })

}

